import React from 'react';
import { NavItem } from '../../framework/nav/NavItem';
import EntryPoints from '../../framework/nav/EntryPoints';
import { motion } from "motion/react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import EmailProtection from '../../framework/common/EmailProtection';

const ResumeView = () => {

  return (
    <div>
      
      <Container fluid={true}>
        <div className="resume-container">
          {/* Header Section */}
          <div className="resume-header text-center mb-5">
            <h1 className="display-4 fw-bold">Luca Morrow</h1>
            <h3 className="text-muted mb-3">Software Developer & Engineering Student</h3>
            <div className="contact-info">
              <p className="mb-1">
                <EmailProtection className="text-decoration-none" /> | 
                <a href="https://au.linkedin.com/in/lucamorrow" className="text-decoration-none ms-2">LinkedIn</a> | 
                <a href="https://drive.google.com/file/d/1RojvYUEhmA_f36Nueg7meY_s6VdtjHh9/view" className="text-decoration-none ms-2">Resume PDF</a>
              </p>
              <p className="text-muted">The University of Sydney | Software Engineering Student</p>
            </div>
          </div>


          {/* Professional Summary */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Summary</h2>
            <p className="lead">
              Third-year Software Engineering student at The University of Sydney 
              with hands-on experience designing and building user-centric digital 
              products, including three full-stack apps published on the Atlassian 
              Marketplace using Forge. Skilled in translating user needs into 
              intuitive, functional designs, with a strong focus on usability, 
              iteration, and end-to-end product thinking. Proven ability to 
              collaborate and deliver impactful solutions in fast-paced 
              environments. Seeking to apply technical and creative skills to a 
              high-impact software engineering internship.
            </p>
          </section>
          

          {/* Education */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Education</h2>
            <div className="education-item">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h4 className="mb-1">Bachelor of Engineering Honours (Software Engineering)</h4>
                  <p className="text-muted mb-1">The University of Sydney</p>
                  <li className="mb-0">Currently in third year, focusing on software development, algorithms, and UI design.</li>
                  <li className="mb-0">Actively participate in several societies, including the Software Engineering Society, Robotics Club, SYNCS and BoulderSoc.</li>
                </div>
                <span className="badge bg-primary">2024 - Present</span>
              </div>
            </div>
            {/* <br/><br/>
            <div className="education-item">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h4 className="mb-1">Software Design and Development (HSC Course)</h4>
                  <p className="text-muted mb-1">Sydney Secondary College Blackwattle Bay Campus</p>
                  <li className="mb-0">Learned about developing and maintaining software, computer architecture, testing methods, and diagramming.</li>
                  <li className="mb-0">Developed multiple Python, React and Arduino projects.</li>
                </div>
                <span className="badge bg-primary">2022 - 2023</span>
              </div>
            </div> */}
          </section>

        

          {/* Projects */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Experience</h2>
            
            <div className="project-item mb-4">
              <Card className="border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                <Card.Body className="p-5">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h4 className="mb-1">QR Code Pro - Confluence App</h4>
                    <span className="badge bg-success">Published</span>
                  </div>
                  <p className="text-muted mb-2">Atlassian Marketplace Application</p>
                  <li>Designed, built and published a Confluence app enabling users to easily generate 
                      customisable QR codes for any URL, with advanced styling and seamless page integration.</li>
                  <li>Used React and Atlassian Forge APIs to deliver a user-friendly experience and seamlessly 
                    integrate with Confluence pages.</li>
                  <li><a href="https://marketplace.atlassian.com/apps/1236040/qr-code-pro">View project.</a></li>
                  <br/>
                  <div className="tech-stack">
                    <span className="badge bg-light text-dark me-2">React</span>
                    <span className="badge bg-light text-dark me-2">Atlassian Forge</span>
                    <span className="badge bg-light text-dark me-2">JavaScript</span>
                    <span className="badge bg-light text-dark">API Integration</span>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="project-item mb-4">
              <Card className="border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                <Card.Body className="p-5">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h4 className="mb-1">Oxal - Spreadsheets for Confluence</h4>
                    <span className="badge bg-success">Published</span>
                  </div>
                  <p className="text-muted mb-2">Atlassian Marketplace Application</p>
                  <li>Created a dynamic spreadsheet application for Confluence that enables teams to embed fully 
                    customisable spreadsheets directly into pages.</li>
                  <li>Features advanced formatting enabled by API-driven functionality.</li>
                  <li><a href="https://marketplace.atlassian.com/apps/1236688/oxal-spreadsheets-for-confluence?hosting=cloud&tab=overview">View project.</a></li>
                  <br/>
                  <div className="tech-stack">
                    <span className="badge bg-light text-dark me-2">React</span>
                    <span className="badge bg-light text-dark me-2">Atlassian Forge</span>
                    <span className="badge bg-light text-dark me-2">Real-time Data</span>
                    <span className="badge bg-light text-dark">API Development</span>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="project-item mb-4">
              <Card className="border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                <Card.Body className="p-5">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h4 className="mb-1">Unsplash for Confluence</h4>
                    <span className="badge bg-success">Published</span>
                  </div>
                  <p className="text-muted mb-2">Atlassian Marketplace Application</p>
                  <li>Developed an application that integrates Unsplash's vast photo library into Confluence.</li>
                  <li>Implemented functionality that allows users to easily add high-quality, license-free 
                    images to their pages with customisable formatting options and positioning controls.</li>
                  <li><a href="https://marketplace.atlassian.com/apps/1236708/unsplash-for-confluence?hosting=cloud&tab=overview">View project.</a></li>
                  <br/>
                  <div className="tech-stack">
                    <span className="badge bg-light text-dark me-2">React</span>
                    <span className="badge bg-light text-dark me-2">Atlassian Forge</span>
                    <span className="badge bg-light text-dark me-2">Unsplash API</span>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="project-item mb-4">
              <Card className="border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                <Card.Body className="p-5">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h4 className="mb-1">Photography & Videography Assistant</h4>
                    <span className="badge bg-primary">2026 - Present</span>
                  </div>
                  <p className="text-muted mb-2">Wesley College</p>
                  <li>Responsible for capturing high-quality footage for marketing and development purposes.</li>
                  <li>Performed effectively in a fast-paced work environment.</li>
                </Card.Body>
              </Card>
            </div>

            <div className="project-item mb-4">
              <Card className="border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                <Card.Body className="p-5">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h4 className="mb-1">Personal Portfolio Website</h4>
                    <span className="badge bg-primary">Live</span>
                  </div>
                  <p className="text-muted mb-2">lucamorrow.com</p>
                  <li>Designed and built a responsive portfolio website showcasing projects, skills, and experience.</li>
                  <li>Through Firebase hosting and Framer Motion libraries, the site features smooth animations, modern UI design, 
                    and optimised performance.</li>
                  <br/>
                  <div className="tech-stack">
                    <span className="badge bg-light text-dark me-2">React</span>
                    <span className="badge bg-light text-dark me-2">TypeScript</span>
                    <span className="badge bg-light text-dark me-2">CSS</span>
                    <span className="badge bg-light text-dark me-2">Motion/Framer</span>
                    <span className="badge bg-light text-dark me-2">Bootstrap</span>
                    <span className="badge bg-light text-dark">Firebase</span>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </section>



          {/* Achievements */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Achievements</h2>
            <Row>
              <Col md={6} className="mb-4">
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5>Airtree Ventures - Airtree Pathfinders</h5>
                    <li>Learned from industry professionals about growing early-stage startups, product-market fit, product strategy, and design trade-offs.</li>
                    <li>Collaborated with peers to make product decisions and present investment insights to industry professionals.</li>
                    <li><a href="https://drive.google.com/file/d/1TyWikSbrKpOccDy3bR-1G6J5yjS1G56y/view">Certificate</a></li>
                  </Card.Body>
                </Card>
              </Col>
            
              <Col md={6}>
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5>Atlassian ForgeHACK & Forge Certification</h5>
                    <li>As a team, developed a Confluence application using Atlassian Forge and Forge UI-kit, and presented it to a group of Atlassian Engineers.</li>
                    <br/>
                    <li>Received Atlassian Forge Certification for completing the Atlassian Forge Fundamentals course and demonstrating proficiency in building applications on the Atlassian platform.</li>
                    <li><a href="https://drive.google.com/file/d/1A5TorQdAI4TU8wUuxbedTxzsJUkG6hYD/view?usp=sharing">Certificate</a></li>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            

            <Row>
              <Col md={6} className="mb-4">
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5>2025 & 2026 Humanitarian Innovation Hackathons</h5>
                    <li>Was a finalist each year, ranking among the top 10 out of ~80 teams.</li>
                    <li>As a team in 2025, proposed and designed a low-cost aquaponics-based food source for rural farmers in Southeast Asia.</li>
                    <li>As a team in 2026, prototyped a web-based AI application for projecting and viewing future climate impacts on Pacific Island communities, helping them prepare for these future events.</li>
                    <li><a href="https://drive.google.com/file/d/1SrU0vcSbBsJIprUcU-j9zhurqSgfG-Kx/view?usp=sharing">Certificates 1</a><a href="https://drive.google.com/file/d/14PtzD20t-xi5pxA9YlPb71weSDVaiv2s/view"> & 2</a></li>
                  </Card.Body>
                </Card>
              </Col>

            </Row>
          </section>



          {/* Technical Skills */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Technical Skills</h2>
            <Row>
              <Col md={6}>
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5 className="card-title">Programming Languages</h5>
                      <li>JavaScript/TypeScript</li>
                      <li>Python</li>
                      <li>Java</li>
                      <li>C++</li>
                      <li>HTML/CSS/SCSS</li>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5 className="card-title">Frameworks & Technologies</h5>
                    <li>React.js</li>
                    <li>Atlassian Forge</li>
                    <li>Bootstrap & Tailwind CSS</li>
                    <li>Motion/Framer Motion</li>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={6}>
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5 className="card-title">Design & Modelling</h5>
                      <li>Figma (UI/UX Design)</li>
                      <li>Blender (3D Modelling & Rendering)</li>
                      <li>CAD Design</li>
                      <li>Photo Editing</li>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="h-100 border-0" style={{ boxShadow: '0 0 24px rgba(0,0,0,0.22)' }}>
                  <Card.Body className="p-5">
                    <h5 className="card-title">Other Technologies</h5>
                      <li>Git Version Control (Bitbucket/Github)</li>
                      <li>Firebase Hosting</li>
                      <li>Jira</li>
                      <li>API Implementation</li>
                      <li>Microcontroller Development</li>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>



          {/* Additional Skills & Interests */}
          <section className="mb-5">
            <h2 className="border-bottom pb-2 mb-4">Additional Skills & Interests</h2>
            <Row>
              <Col md={6}>
                <h5>3D Modelling & Design</h5>
                <p>
                  Experienced in 3D modelling, lighting, and rendering using Blender software. Created various 3D models for 
                  personal and academic projects, focusing on realistic lighting and material design.
                </p>
              </Col>
              <Col md={6}>
                <h5>Creative Technologies</h5>
                <p>
                  Passionate about exploring creative applications of technology including 3D printing, 
                  photography, microcontroller development, and finding innovative ways to integrate 
                  technology into creative projects.
                </p>
              </Col>
            </Row>
          </section>

          {/* Contact */}
          <section className="text-center mt-5 pt-4 border-top">
            <p className="text-muted">
              For collaboration opportunities or project inquiries, please reach out via 
              <EmailProtection className="text-decoration-none ms-1" /> or 
              <a href="https://au.linkedin.com/in/lucamorrow" className="text-decoration-none ms-1">LinkedIn</a>.
            </p>
          </section>
        </div>
      </Container>
    </div>
  );
};

class ResumeEntryPoints implements EntryPoints {

  renderFullView = (navItem: NavItem, secondaryNavItems: string[], width: number, height: number): any => {
    return <ResumeView />;
  }

renderIntroView = (navItem: NavItem, secondaryNavItems: string[]): any => {
  return (
    <span>Professional resume showcasing experience and skills</span>
  );
}

}

const resumeEntryPoints = new ResumeEntryPoints();
export default resumeEntryPoints;